import { withProps } from 'recompose';
import Item from './Item';
import { formatBoolean } from '../../utils/format';

const YesNoItem = withProps(({ value }) => ({ value: formatBoolean(value) }))(Item);

export default YesNoItem;
